import Vue from "vue"
import Vapi from "vuex-rest-api"

const shows = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    show: null,
    shows: [],
    allShows: [],
    showPeople: [],
    allShowPeople: [],
    showInstruments: [],
    allShowInstruments: [],
    showBands: [],
    allShowBands: [],
    showPlaces: [],
    allShowPlaces: [],
    showPersonOptions: {},
    showHotels: [],
    allShowHotels: [],
    showRooms: [],
    allShowRooms: [],
  },
})

  // shows
  .get({
    action: "retrieveShow",
    property: "show",
    path: ({ id }) => `/shows/${id}/`,
  })
  .get({
    action: "listShows",
    property: "shows",
    path: "/shows/",
  })
  .get({
    action: "listAllShows",
    property: "allShows",
    path: "/shows/?no_page=1",
  })
  .post({
    action: "createShow",
    property: "show",
    path: "/shows/",
  })
  .patch({
    action: "updateShow",
    property: "show",
    path: ({ id }) => `/shows/${id}/`,
  })
  .delete({
    action: "destroyShow",
    path: ({ id }) => `/shows/${id}/`,
  })

  // showPeople
  .get({
    action: "listShowPeople",
    property: "showPeople",
    path: ({ showId }) => `/show-people/?show=${showId}`,
  })
  .get({
    action: "listAllShowPeople",
    property: "allShowPeople",
    path: ({ showId }) => `/show-people/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createShowPerson",
    path: "/show-people/",
  })
  .patch({
    action: "updateShowPerson",
    path: ({ id }) => `/show-people/${id}/`,
  })
  .delete({
    action: "destroyShowPerson",
    path: ({ id }) => `/show-people/${id}/`,
  })

  // show

  // showInstruments

  .get({
    action: "listShowInstruments",
    property: "showInstruments",
    path: ({ showId }) => `/show-instruments/?show=${showId}`,
  })
  .get({
    action: "listAllShowInstruments",
    property: "allShowInstruments",
    path: ({ showId }) => `/show-instruments/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createShowInstrument",
    path: "/show-instruments/",
  })
  .patch({
    action: "updateShowInstrument",
    path: ({ id }) => `/show-instruments/${id}/`,
  })
  .delete({
    action: "destroyShowInstrument",
    path: ({ id }) => `/show-instruments/${id}/`,
  })

  // showBands

  .get({
    action: "listShowBands",
    property: "showBands",
    path: ({ showId }) => `/show-bands/?show=${showId}`,
  })
  .get({
    action: "listAllShowBands",
    property: "allShowBands",
    path: ({ showId }) => `/show-bands/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createShowBand",
    path: "/show-bands/",
  })
  .patch({
    action: "updateShowBand",
    path: ({ id }) => `/show-bands/${id}/`,
  })
  .delete({
    action: "destroyShowBand",
    path: ({ id }) => `/show-bands/${id}/`,
  })

  // showPerson options

  .get({
    action: "retrieveShowPersonOptions",
    property: "showPersonOptions",
    path: ({ id }) => `/shows/${id}/person_options/`,
  })
  .patch({
    action: "updateShowPersonOptions",
    property: "showPersonOptions",
    path: ({ id }) => `/shows/${id}/person_options/`,
  })

  // showPlaces

  .get({
    action: "listShowPlaces",
    property: "showPlaces",
    path: ({ showId }) => `/show-places/?show=${showId}`,
  })
  .get({
    action: "listAllShowPlaces",
    property: "allShowPlaces",
    path: ({ showId }) => `/show-places/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createShowPlace",
    path: "/show-places/",
  })
  .patch({
    action: "updateShowPlace",
    path: ({ id }) => `/show-places/${id}/`,
  })
  .delete({
    action: "destroyShowPlace",
    path: ({ id }) => `/show-places/${id}/`,
  })

  // showHotels

  .get({
    action: "listShowHotels",
    property: "showHotels",
    path: ({ showId }) => `/show-hotels/?show=${showId}`,
  })
  .get({
    action: "listAllShowHotels",
    property: "allShowHotels",
    path: ({ showId }) => `/show-hotels/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createShowHotel",
    path: "/show-hotels/",
  })
  .patch({
    action: "updateShowHotel",
    path: ({ id }) => `/show-hotels/${id}/`,
  })
  .delete({
    action: "destroyShowHotel",
    path: ({ id }) => `/show-hotels/${id}/`,
  })

  // showRooms

  .get({
    action: "listShowRooms",
    property: "showRooms",
    path: ({ showId }) => `/show-rooms/?show=${showId}`,
  })
  .get({
    action: "listAllShowRooms",
    property: "allShowRooms",
    path: ({ showId }) => `/show-rooms/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createShowRoom",
    path: "/show-rooms/",
  })
  .patch({
    action: "updateShowRoom",
    path: ({ id }) => `/show-rooms/${id}/`,
  })
  .delete({
    action: "destroyShowRoom",
    path: ({ id }) => `/show-rooms/${id}/`,
  })

  // finalize
  .getStore()

export default shows
